export const getEquipTypeName = (state, etid) => state.entities.equipTypes.byId[etid]?.nameLong;
